<div class="dialogue-content">
    <div class="mat-dialogue-header">
        <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">{{ lableConstant.BookedCustomerList }}</h4>
        <button type="button" class="btn-close" aria-label="Close" [mat-dialog-close]="false"></button>
    </div>
    <mat-dialog-content>
        <div class="d-flex align-items-center justify-content-between gap-3 flex-wrap">
            <div class="d-flex"></div>
            <div class="position-relative">
                <input type="text" placeholder="Search" class="form-control search-box mb-3" [(ngModel)]="searchKeyword"
                    (keyup)="applyFilter($event)" />
                <i *ngIf="searchKeyword" class="fa-solid fa-times search-icon" (click)="clearSearch()"></i>
                <i *ngIf="!searchKeyword" class="fa-solid fa-magnifying-glass search-icon"></i>
            </div>
        </div>
        <ng-container *ngIf="customerList?.length > 0; else noData">
            <div *ngFor="let session of customerList">
                <div class="card mb-3">
                    <div class="card-header mt-2">
                        <h5>{{ lableConstant.ClassName }} {{ session.className }}</h5>
                    </div>
                    <div class="card-body">
                        <div class="mat-custom-table">
                            <div class="table-responsive">
                                <table class="w-100" mat-table [dataSource]="session.customers">
                                    <ng-container matColumnDef="CustomerName">
                                        <th mat-header-cell *matHeaderCellDef>{{ lableConstant.CustomerName }}</th>
                                        <td mat-cell *matCellDef="let customer">
                                            <div class="d-flex align-items-center">
                                                <img (error)="handleImageError(customer)"
                                                    [src]="customer.images || '../../../assets/img/default-customer-profile.svg'"
                                                    class="img-fluid profile-pic-table me-2" width="40px" />
                                                <span class="WrapData">{{ customer.firstName }} {{ customer.lastName
                                                    }}</span>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Email">
                                        <th mat-header-cell *matHeaderCellDef>{{ lableConstant.Email }}</th>
                                        <td mat-cell *matCellDef="let customer">
                                            <div class="WrapData" title="{{ customer.email }}">
                                                {{ customer.email }}
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="ExpiryDate">
                                        <th mat-header-cell *matHeaderCellDef>{{ lableConstant.PassExpiryDate }}</th>
                                        <td mat-cell *matCellDef="let customer"
                                            [title]="customer.passExpiryDate | date:dateFormat.titleFormat"
                                            [innerHTML]="customer.passExpiryDate | ordinalDate : customer.passExpiryDate">
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="PassStatus">
                                        <th mat-header-cell *matHeaderCellDef>{{ lableConstant.PassStatus }}</th>
                                        <td mat-cell *matCellDef="let customer">
                                            <div class="WrapData" title="{{ customer.expiryStatus }}">
                                                {{ customer.expiryStatus }}
                                            </div>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #noData>
            <h5 class="text-center py-4">{{ lableConstant.NoRecordFound }}</h5>
        </ng-template>
    </mat-dialog-content>
</div>